/** Version id for onboarding marketing checkbox copy (audit trail). */
export const MARKETING_OPT_IN_TEXT_VERSION = 'onboarding-v1';

export const MARKETING_OPT_IN_SOURCE_ONBOARDING = 'onboarding';
export const MARKETING_OPT_IN_SOURCE_SETTINGS = 'settings';
